import EmailHealthTestResults from "@/components/popups/email-health-test-results";
import { useEmailHealthReport } from "./email-health-context";
import {
  EmailHealthHeader,
  EmailHealthSummaryCards,
} from "./email-health-header";
import EmailHealthProblems from "./email-health-problems";
import ConsultationBanner from "@/components/consultation-banner";
import EmailHealthDeliveryChain from "./email-health-delivery-chain";
import {
  EmailHealthDomainAge,
  EmailHealthDomainReputation,
} from "./email-health-domain-info";
import EmailHealthBlacklist from "./email-health-blacklist";
import EmailHealthOpenRelay from "./email-health-open-relay";
import RunEmailTest from "../run-email-test-from-report";
import { usePermission } from "@/hooks/use-premission";
import EmailHealthRecords from "./email-health-records";

const EmailHealthReport = () => {
  const { recordsData, state } = useEmailHealthReport();
  const { hasPermission } = usePermission();
  return (
    <div className="w-full" id="email-health-print">
      <EmailHealthHeader />
      <EmailHealthSummaryCards />

      {hasPermission("email_health:run_test") && !state.isPrinting && (
        <RunEmailTest
          espType={recordsData?.espType || "smtp"}
          isMailboxConnected={recordsData?.mailboxConnected || false}
          domain={recordsData?.domain}
        />
      )}

      {/* content details */}
      <EmailHealthTestResults
        testResults={recordsData?.emailHealthData}
        emailSize={
          recordsData?.emailSize ? Number(recordsData?.emailSize) : undefined
        }
        isPrinting={state.isPrinting}
      />

      {/* problems */}
      <EmailHealthProblems healthcheck={recordsData?.healthcheck} />

      {/* book a call */}
      <ConsultationBanner type="email-health" className="mb-4" />

      {/* email delivery chain */}
      <EmailHealthDeliveryChain
        deliveryChain={(recordsData?.formattedReceivedChain  || recordsData?.recievedChain || []) as any}
      />

      {/* email health results */}
      <EmailHealthRecords />

      {/* domain age */}
      <EmailHealthDomainAge recordsData={recordsData} />

      {/* domain reputation */}
      <EmailHealthDomainReputation domainReport={recordsData?.domainReport} />

      {/* blacklist */}
      <EmailHealthBlacklist
        domainBlacklist={recordsData?.domainBlacklist || []}
        mxServerBlacklist={recordsData?.mxServerBlacklists || []}
        smtpBlacklist={recordsData?.smtpBlacklist || []}
      />

      {/* open relay check */}
      <EmailHealthOpenRelay relaycheck={recordsData?.relaycheck} />
    </div>
  );
};

export default EmailHealthReport;
